import { render, staticRenderFns } from "./PlantView.vue?vue&type=template&id=673dcd42"
import script from "./PlantView.vue?vue&type=script&lang=ts"
export * from "./PlantView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports